import './App.scss';
import Routes from "./Router";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_OAUTH } from './config/config';
import { AuthProvider } from './auth';

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_OAUTH.CLIENT_ID}>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;

